import * as React from "react"
import { Box, Badge } from "@mui/material";
import { TooltipSeeker } from "@ui-seeker/core";
import { formatPriceSymbol } from "@ui-seeker/utils";

import {useUserApp} from "@hooks"
import {BadgeVariant} from "@components"


export default function prevPriceColumn() {
	return {
		name: 'prevPrice', label: 'Previous Price',
		options: {
			filter: false,
			customBodyRowRender: (value, { currency, prevPriceStock, numVariants }) => <PrevPriceCell
				value={value}
				currency={currency}
				prevPriceStock={prevPriceStock}
				numVariants={numVariants}
			/>
		}
	}
}

const PrevPriceCell = ({ value, currency, prevPriceStock, numVariants }) =>{
	const { userGroupByProductID } = useUserApp()

	return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
		{formatPriceSymbol(value, currency)}
		<TooltipSeeker title={prevPriceStock ? 'In Stock' : 'Out of Stock'} >
			<Badge
				color={prevPriceStock ? 'success' : 'error'}
				badgeContent=""
				sx={{ ml: 2, mr: 1 }}
			/>
		</TooltipSeeker>
		{ !userGroupByProductID && !!prevPriceStock && <BadgeVariant numVariants={numVariants} /> }
	</Box>
}